import { loadGroupedPresets } from 'components/Presets/sources/presets';

import { useQuery } from '@gogame/query';

import { groupedPresets } from './queryKeyFactory';

export const useLoadGroupedPresets = ({ enabled, ...params }) => {
  return useQuery(
    groupedPresets(params),
    (_, { signal }) => loadGroupedPresets(params, { signal }),
    {
      enabled,
    }
  );
};
